export default {
  computed: {
    required () {
      return [
        v => (!!v || v === 0) || 'This field is required',
      ]
    },

    validateRequireAtLeastOne () {
      return [
        v => (v && v.length) || 'There should be at least one provided',
      ]
    },

    validateEmailNotRequired () {
      return [
        v => !v || this.isValidEmail(v) || 'Please enter a valid email address',
      ]
    },

    validateEmail () {
      return [
        v => !!v || 'Email address is required',
        v => this.isValidEmail(v) || 'Please enter a valid email address',
      ]
    },
    validateName () {
      return [
        v => !!v || 'Name is required',
        v => (v && (v.trim().match(/ /g) || []).length > 0) || 'Please provide full name (first and last)',
      ]
    },
    validatePassword () {
      return [
        v => !!v || 'Password is required',
        v => (v && v.length >= 6) || 'Password must be at least 6 characters',
      ]
    },

    validatePhoneNotRequired () {
      return [
        v => !v || /^\(\d{3}\)\d{3}-\d{4}/.test(v) || 'That does not appear to be a valid phone number',
      ]
    },

    validatePhone () {
      return [
        v => !!v || 'Phone number is required',
        v => (v && /^\(\d{3}\)\d{3}-\d{4}/.test(v)) || 'That does not appear to be a valid phone number',
      ]
    },
  },
  methods: {
    isValidEmail (email) {
      return /^[!#$%&'*+\-/=?^_`{|}~a-zA-Z0-9.]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+$/.test(email)
    },
  },
}
